import * as SentryBrowser from '@sentry/browser';
let Sentry: typeof SentryBrowser | null = SentryBrowser;
if (process.env.SENTRY) {
  Sentry.init({
    dsn: 'https://e865442517f244e68760782b5ceddbb9@o4504870095880192.ingest.sentry.io/4504931345563648',
    environment: process.env.ENV,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    //tracesSampleRate: 0,
    //sampleRate: 0,
    //replaysSessionSampleRate: 0,
    //replaysOnErrorSampleRate: 0,
    release: process.env.RELEASE,
    defaultIntegrations: false,
    //integrations: [new Sentry.Replay(), new Sentry.BrowserTracing()],
  });
} else {
  Sentry = null;
}
export { Sentry };
